import React from 'react';
import { Calendar, Clock } from 'lucide-react';

export const TourMockInbox: React.FC = () => {
  return (
    <div className="w-full bg-subtle/50 rounded-xl border border-border shadow-lg overflow-hidden aspect-video flex flex-col">
      <div className="bg-white border-b border-border px-4 py-3 flex justify-between items-center">
        <div className="flex items-center gap-2">
            <div className="p-1.5 bg-ink text-white rounded">
                <Calendar size={12} />
            </div>
            <span className="text-sm font-bold text-ink">Minha Inbox</span>
        </div>
      </div>

      <div className="p-3 space-y-2 overflow-hidden">
        <div className="bg-white p-3 rounded-lg border border-border shadow-sm flex items-start gap-3">
           <div className="mt-1 w-4 h-4 rounded border-2 border-border"></div>
           <div className="flex-1">
             <p className="text-sm font-medium text-ink">Atualizar deck de vendas</p>
             <div className="flex items-center gap-2 mt-1">
               <span className="text-[10px] bg-red-50 text-red-600 px-1.5 py-0.5 rounded font-medium border border-red-100">Hoje</span>
               <span className="text-[10px] text-muted flex items-center gap-1"><Clock size={10}/> 16:00</span>
             </div>
           </div>
        </div>
      </div>
    </div>
  );
};